import { listItemButtonClasses, styled } from '@mui/material';
import { NavSubListItem } from '@procureai/ui-mui';

export const NavSubListItemStyled = styled(NavSubListItem)(({ theme }) => ({
  [`&.${listItemButtonClasses.selected}::before`]: {
    content: '""',
    display: 'block',
    position: 'absolute',
    backgroundColor: theme.palette.secondary.main,
    width: 6,
    height: 6,
    top: '50%',
    right: 10,
    marginRight: -3,
    marginTop: -3,
    borderRadius: '50%',
  },
}));
